const INITIAL_STATE = {
    selectedCountry: '',
    L : {},
    waitLang : 0
}


const settingsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "setSelectedCountry" : return {...state, selectedCountry: action.payload};
        case "SetLang" : return {...state, L: action.payload};
        case "SetLangStatus" : return {...state, waitLang: action.payload};
        default : return state;
    }
}


export default settingsReducer;